export default {

  init() {
    this.toggleWhatsappShare();
  },

  isMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /Android|\\bBB10\\b|rim tablet os|BlackBerry|iPhone|iPad|iPod|AppleCoreMedia|Opera Mini|Windows Phone|Windows Mobile|IEMobile/i.test(userAgent);
  },

  /**
   * Check if the device is mobile/tablet
   */
  toggleWhatsappShare() {
    if (!this.isMobileOS()) {
      return;
    }
    const whatsAppButton = document.getElementsByClassName('social-share__whatsapp');
    if (whatsAppButton.length) {
      whatsAppButton[0].classList.remove('u-hide');
    }
  },
}
